import decodeHtml from 'utilities/decodeHtml';

import queueUtagCall from './queueUtagCall';

function utagLinkProductImpressions (params) {

	if (params && typeof params === 'object') {

		queueUtagCall(() => {

			const decodedNames = params.product_impression_name
				? [ ...params.product_impression_name.map((val) => decodeHtml(val)) ]
				: [];

			const utagLinkParams = {
				event_category: 'ecommerce',
				event_action: 'product impression',
				event_label: document.location.href,
				event_noninteraction: 'true',
				product_impression_sku: params.product_impression_sku || [],
				product_impression_name: decodedNames,
				product_impression_price: params.product_impression_price || [],
				product_impression_list: params.product_impression_list || [],
				product_impression_position: params.product_impression_position || [],
				product_impression_category: params.product_impression_category || [],

				product_primary_category: params.primaryCategory || [],
				product_primary_color: params.primaryColor || [],
				product_primary_finish: params.primaryFinish || [],
				product_primary_type: params.primaryType || [],
				product_primary_style: params.primaryStyle || [],

				list_type: params.list_type || null,
				filter_id: params.filter_id || [],
				test_id: params.test_id || [],
				testcomposition_id: params.testcomposition_id || [],
				mm_id: params.mm_id || [],
				formula_id: params.formula_id || [],
				pin_id: params.pin_id || [],
				test_start_date: params.test_start_date || [],
				gua_non_interaction: params.gua_non_interaction,
				widget_name: params.widget_name || [],
				vendor_widget: params.vendor_widget || [],
				product_grouping: params.product_grouping || [],
				sku_input_type: params.sku_input_type || []
			};

			window.utag.link(utagLinkParams);

		});

	}

}

export default utagLinkProductImpressions;
